<div nz-row>
    <div nz-col nzSpan="6">
        <span class="pageTitle">User Details</span>
    </div>
    <div nz-col nzSpan="8">
        <div class="search-container">
            <nz-input-group [nzPrefix]="searchIcon">
                <input nz-input type="text" placeholder="Enter minimum 3 characters to search..."
                    [(ngModel)]="searchText" class="search-box" (input)="onSearch()" />
            </nz-input-group>
            <ng-template #searchIcon>
                <i nz-icon nzType="search" style="color: #0b2d71;"></i>
            </ng-template>
        </div>
    </div>
    <div nz-col nzSpan="10">
        <div class="button-container"
            style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" style="margin-right: 10px;" [routerLink]="'/admin/add-user'">
                <i nz-icon nzType="file-add" nzTheme="outline" style="color: white;"></i> Add New User
            </button>
            <button nz-button nzType="primary" style="margin-right: 10px;" (click)="exportToExcel()"
                [disabled]="!filteredUserMaster.length">
                <i nz-icon nzType="file-add" nzTheme="outline" style="color: white;"></i> Export to excel
            </button>
        </div>
    </div>
</div>

<nz-table #userDetailsTable [nzData]="filteredUserMaster" [nzLoading]="showTableLoader" [nzBordered]="true"
    [nzSize]="'small'" [nzShowPagination]="true">
    <thead>
        <tr>
            <th *ngFor="let column of listOfColumn" [nzShowSort]="column.allowSorting" [nzSortFn]="column.compare"
                [nzSortPriority]="column.priority" style="padding: 5px;">
                {{ column.title }}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let user of userDetailsTable.data">
            <td><a style="cursor: pointer; " (click)="viewUser(user)">
                    <strong>{{user.User_Name}}</strong></a></td>
            <td>{{user.Email}}</td>
            <td>{{user.CAI}}</td>
            <td>{{user.Roles}}</td>
            <td>{{user.Company.Company_Name}}</td>
            <td>{{user.Block.Block_Name}}</td>
            <td>{{user.Status}}</td>
            <td>
                <button style="font-size: 80%;" *ngIf="user.Active" nz-button nzType="primary" [nzSize]="'small'"
                    value="Edit" (click)="openEditUserPopup(user)">Edit</button>
                <button *ngIf="user.Active" nz-button nzType="primary" [nzSize]="'small'" value="De-Activate"
                    (click)="openDeactivateModal(user)" style="margin-left: 5px;font-size: 80%;">De-Activate</button>
                <button style="font-size: 80%;" nz-button nzType="primary" [nzSize]="'small'" value="Re-Activate"
                    *ngIf="!user.Active && (!user.Is_Partner || user.Company.Active)"
                    (click)="openReactivateModal(user)">Re-Activate</button>
            </td>
        </tr>
    </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isVisible" nzTitle="View User" (nzOnCancel)="handleCancel()" [nzClosable]="false" [nzWidth]="'800px'">
    <div *nzModalContent>
        <div class="row form-group">
            <div class="col-md-2">User Name :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.User_Name" /></div>
            <div class="col-md-2">Email :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.Email" /> </div>
        </div>
        

        <div class="row form-group" *ngIf="!selectedUser.Is_Partner">
            <div class="col-md-2">CAI :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.CAI" /></div>
            <div class="col-md-2">Job Title :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.JobTitle" /> </div>
        </div>

        <div class="row form-group" *ngIf="!selectedUser.Is_Partner">
            <div class="col-md-2">CTN :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.CTN" /></div>                
        </div>
        <div class="row form-group" *ngIf="!selectedUser.Is_Partner">
            <div class="col-md-2">CAI :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.CAI" /></div>
            <div class="col-md-2">Job Title :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.JobTitle" /> </div>
        </div>

        <div class="row form-group" *ngIf="selectedUser.Is_Partner">
            <div class="col-md-2">Company :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.Company.Company_Name" /></div>
            <div class="col-md-2">Block :</div>
            <div class="col-md-4"><input nz-input disabled [value]="selectedUser.Block.Block_Name" /> </div>
        </div>
        
        <div class="row form-group">
            <div class="col-md-2">User Roles :</div>
            <div class="col-md-10">
                <strong style="font-size: 90%;">{{selectedUser.Roles}}</strong> 
            </div>
        </div>

    </div>
    <div *nzModalFooter>
        <button nz-button nzType="default" (click)="handleCancel()">Cancel</button>
    </div>
</nz-modal>

<nz-modal [(nzVisible)]="showEditUserModal" nzTitle="View User" (nzOnCancel)="handleCancelEdit()" [nzClosable]="false"
    [nzWidth]="'800px'">
    <div *nzModalContent>        
        <div class="modal-body">
            <div class="row form-group">
                <div class="col-md-2">User Name :</div>
                <div class="col-md-4"><input nz-input disabled [value]="editSelectedUser.User_Name" /></div>
                <div class="col-md-2">Email :</div>
                <div class="col-md-4"><input nz-input disabled [value]="editSelectedUser.Email" /> </div>
            </div>

            <div class="row form-group" *ngIf="!editSelectedUser.Is_Partner">
                <div class="col-md-2">CAI :</div>
                <div class="col-md-4"><input nz-input disabled [value]="editSelectedUser.CAI" /></div>
                <div class="col-md-2">Job Title :</div>
                <div class="col-md-4"><input nz-input disabled [value]="editSelectedUser.JobTitle" /> </div>
            </div>

            <div class="row form-group" *ngIf="!editSelectedUser.Is_Partner">
                <div class="col-md-2">CTN :</div>
                <div class="col-md-4"><input nz-input disabled [value]="editSelectedUser.CTN" /></div>                
            </div>

            <form [formGroup]="editUserForm" nz-form class="ant-advanced-search-form"> 
                <div class="row form-group" *ngIf="editSelectedUser.Is_Partner">
                    <div class="col-md-2">Company :</div>
                    <div class="col-md-4">
                        <nz-select id="company" formControlName="company" nzPlaceHolder="Select a company"
                            style="width: 100%;">
                            <nz-option *ngFor="let company of companyMaster" [nzValue]="company.Company_Code"
                                [nzLabel]="company.Company_Name">
                            </nz-option>
                        </nz-select>
                        <div *ngIf="editUserForm.get('company')?.touched && editUserForm.get('company')?.invalid"
                            class="text-danger">
                            Company is required.
                        </div>
                    </div>
                    <div class="col-md-2">Block :</div>
                    <div class="col-md-4">
                        <nz-select id="block" formControlName="block" nzPlaceHolder="Select a block"
                            style="width: 100%;">
                            <nz-option *ngFor="let block of blockMaster" [nzValue]="block.Block_Code"
                                [nzLabel]="block.Block_Name">
                            </nz-option>
                        </nz-select>
                        <div *ngIf="editUserForm.get('block')?.touched && editUserForm.get('block')?.invalid"
                            class="text-danger">
                            Block is required.
                        </div>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-3">Application Roles :</div>
                    <div class="col-md-9" formArrayName="applicationRoles">
                        <label class="ant-checkbox-wrapper ant-checkbox-group-item ng-star-inserted"
                                *ngFor="let choice of checkboxOptions; let i=index">
                                <input nz-input type="checkbox" [formControlName]="i" [value]="choice.value" (change)="onRolesChange($event)">
                                {{choice.label}}
                            </label>
                        <div class="text-danger" *ngIf="selectedRoles.length === 0">Application roles required</div>
                    </div>                
                </div>
                 
            </form>


        </div>
    </div>
    <div *nzModalFooter>
        <button nz-button nzType="primary" type="submit" (click)="onSubmitEdit()">Submit</button>
        <button nz-button nzType="default" (click)="handleCancelEdit()">Cancel</button>
    </div>
</nz-modal>
